export class BaseSheet {
  id: number
  sheet_code: string
  name: string
  curriculum_id: number
  grade: number
  level: string

  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.name = base_sheet.name;
    this.curriculum_id = base_sheet.curriculum_id;
    this.grade = base_sheet.grade;
    this.level = base_sheet.level;
  }
}

export class BaseSheetField {
  id: number
  kind: number
  part1: string
  part2: string
  part3: string
  allot: number
  page: number
  field_kind: number

  constructor(sheet_field_base: any){
    this.id = sheet_field_base.id;
    this.kind = sheet_field_base.kind;
    this.part1 = sheet_field_base.part1;
    this.part2 = sheet_field_base.part2;
    this.part3 = sheet_field_base.part3;
    this.allot = sheet_field_base.allot;
    this.page = sheet_field_base.page;
    this.field_kind = sheet_field_base.field_kind;
  }
}